import { Button, Divider, Input, Select, Upload, message } from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
// import { toPng } from "html-to-image";
import { UploadOutlined, DownloadOutlined } from "@ant-design/icons";
// import AvatarItem from "./components/AvatarItem";
// import html2canvas from "html2canvas";
// import ReactDOM from "react-dom";
import { useMediaQuery } from "react-responsive";
import axios from "axios";

function generateRandomString(length) {
  const characters =
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let result = "";

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }

  return result;
}

const RenderPoster = () => {
  const [title, setTitle] = useState("BẢNG VÀNG VINH DANH");
  const [projectName, setProjectName] = useState("GOLDEN WEST");
  const [paymentType, setPaymentType] = useState("Bán");
  const [departmentCode, setDepartmentCode] = useState("S1.085A12");
  const [departmentValue, setDepartmentValue] = useState("4.8 tỷ");
  const [bonus, setBonus] = useState("06/08/2025");
  const [isLoading, setIsLoading] = useState(false);
  const [statusLoading, setStatusLoading] = useState(true);
  const canvasRefB = useRef(null);
  const [typeImage, setTypeImage] = useState(1);
  const [isMobile, setIsMobile] = useState(false);
  const [isIphone, setIsIphone] = useState(false);

  const [hidenView, setHidenView] = useState(true);

  const [avtObj, setAvtObj] = useState([
    { file: "", name: "", id: generateRandomString(12) },
  ]);

  const uploadProps = (index) => ({
    beforeUpload: (file) => {
      const isImage = file.type.startsWith('image/');
      if (!isImage) {
        message.error('Vui lòng chọn file ảnh!');
        return false;
      }
      
      const reader = new FileReader();
      reader.onloadend = () => {
        const newAvtObj = [...avtObj];
        newAvtObj[index] = {
          ...newAvtObj[index],
          file: reader.result,
        };
        setAvtObj(newAvtObj);
      };
      reader.readAsDataURL(file);
      return false;
    },
    onRemove: () => {
      const newAvtObj = [...avtObj];
      newAvtObj[index] = {
        ...newAvtObj[index],
        file: "",
      };
      setAvtObj(newAvtObj);
    },
    fileList: [],
  });

  const [canvasA1Element, setCanvasA1] = useState(null);

  useEffect(() => {
    if (isMobile) return;
    
    let isMounted = true;
    
    const initCanvas = async () => {
      try {
        await createCanvas();
      } catch (error) {
        console.error("Error initializing canvas:", error);
        message.error("Lỗi khởi tạo canvas. Vui lòng thử lại.");
      }
    };

    initCanvas();

    return () => {
      isMounted = false;
      if (canvasA1Element) {
        const ctx = canvasA1Element.getContext('2d');
        ctx.clearRect(0, 0, canvasA1Element.width, canvasA1Element.height);
      }
    };
  }, [
    title,
    projectName,
    paymentType,
    departmentCode,
    departmentValue,
    bonus,
    typeImage,
    avtObj,
  ]);

  useEffect(() => {
    if (!canvasA1Element) return;

    const canvasB = canvasRefB.current;
    if (!canvasB) return;

    try {
      const ctxB = canvasB.getContext("2d");
      ctxB.clearRect(0, 0, canvasB.width, canvasB.height);
      ctxB.drawImage(canvasA1Element, 0, 0, canvasB.width, canvasB.height);
    } catch (error) {
      console.error("Error updating canvas:", error);
      message.error("Lỗi cập nhật canvas. Vui lòng thử lại.");
    }
  }, [canvasA1Element, statusLoading]);

  const createCanvas = async () => {
    setStatusLoading(true);
    try {
      const canvasA1 = document.createElement("canvas");
      const ctxA1 = canvasA1.getContext("2d");
      const image = new Image();
      image.src = rederBackGround(avtObj, typeImage);
      
      await new Promise((resolve, reject) => {
        image.onload = () => {
          canvasA1.width = image.width;
          canvasA1.height = image.height;
          ctxA1.drawImage(image, 0, 0, canvasA1.width, canvasA1.height);

          insertText(
            ctxA1,
            "GIAO DỊCH THÀNH CÔNG",
            "35px UTM BanqueB, sans-serif",
            "#F5D186",
            "center",
            canvasA1.width / 2,
            typeImage === 1 ? 960 : 290
          );

          resolve();
        };
        image.onerror = reject;
      });

      insertText(
        ctxA1,
        title,
        typeImage === 1
          ? `bold 38px UTM Akashi, sans-serif`
          : `bold 50px UTM Akashi, sans-serif`,
        "white",
        "center",
        canvasA1.width / 2,
        typeImage === 1 ? 152 : 70
      );

      await renderAvatarUser(ctxA1, canvasA1, avtObj, typeImage);

      await new Promise((resolve) => {
        insertText(
          ctxA1,
          projectName,
          "bold 50px UTM BanqueB, sans-serif",
          "#F5D186",
          "center",
          canvasA1.width / 2,
          typeImage === 1 ? (isIphone ? 1090 : 1070) : isIphone ? 405 : 385
        );

        insertText(
          ctxA1,
          paymentType,
          "bold 28px UTM Centur, sans-serif",
          "#401C0E",
          "center",
          getPositionItem(avtObj, typeImage, "paymentType").x,
          getPositionItem(avtObj, typeImage, "paymentType").y
        );

        insertText(
          ctxA1,
          departmentCode,
          "bold 28px UTM Centur, sans-serif",
          "#401C0E",
          "center",
          getPositionItem(avtObj, typeImage, "departmentCode").x,
          getPositionItem(avtObj, typeImage, "departmentCode").y
        );

        insertText(
          ctxA1,
          departmentValue,
          "bold 28px UTM Centur, sans-serif",
          "#401C0E",
          "center",
          getPositionItem(avtObj, typeImage, "departmentValue").x,
          getPositionItem(avtObj, typeImage, "departmentValue").y
        );

        insertText(
          ctxA1,
          bonus,
          "bold 28px UTM Centur, sans-serif",
          "#401C0E",
          "center",
          getPositionItem(avtObj, typeImage, "bonus").x,
          getPositionItem(avtObj, typeImage, "bonus").y
        );
        resolve();
      });

      setCanvasA1(canvasA1);
    } catch (error) {
      console.error("Error creating canvas:", error);
      message.error("Lỗi tạo canvas. Vui lòng thử lại.");
    } finally {
      setStatusLoading(false);
    }
  };

  const addImage = async (ctxt, linkImage, width, height, objectTet) => {
    const image = new Image();
    const withText = 100;
    const heightwithText = 100;

    image.src = linkImage;
    await new Promise((resolve) => {
      image.onload = () => {
        ctxt.drawImage(image, width, height, image.width, image.height);
        insertText(
          ctxt,
          "thuoc21212",
          "30px Arial",
          "black",
          "center",
          width + withText,
          height + heightwithText
        );
        resolve();
      };
    });
  };

  const getPositionItem = (list, type, typeText) => {
    switch (typeText) {
      case "paymentType":
        if (type === 1) return { x: 170, y: 1208 };

        switch (list.length) {
          case 1:
          case 3:
            return { x: 1280, y: 650 };
          case 2:
          case 4:
            return { x: 240, y: 934 };
          default:
            return { x: 170, y: 1208 };
        }
      case "departmentCode":
        if (type === 1) return { x: 440, y: 1208 };

        switch (list.length) {
          case 1:
          case 3:
            return { x: 1630, y: 650 };
          case 2:
          case 4:
            return { x: 600, y: 934 };
          default:
            return { x: 170, y: 1208 };
        }
      case "departmentValue":
        if (type === 1) return { x: 690, y: 1208 };

        switch (list.length) {
          case 1:
          case 3:
            return { x: 1280, y: 820 };
          case 2:
          case 4:
            return { x: 1300, y: 934 };
          default:
            return { x: 170, y: 1208 };
        }
      case "bonus":
        if (type === 1) return { x: 950, y: 1208 };
        switch (list.length) {
          case 1:
          case 3:
            return { x: 1620, y: 820 };
          case 2:
          case 4:
            return { x: 1650, y: 934 };
          default:
            return { x: 170, y: 1208 };
        }
      default:
        return { x: 170, y: 1208 };
    }
  };

  const rederBackGround = (list, type) => {
    switch (list.length) {
      case 1:
        return type === 1
          ? "/assets/imgs/render-poster/back_ground.jpg"
          : "/assets/imgs/render-poster/back_groundN.jpg";
      case 2:
        return type === 1
          ? "/assets/imgs/render-poster/back_ground.jpg"
          : "/assets/imgs/render-poster/back_groundN2.jpg";
      case 3:
        return type === 1
          ? "/assets/imgs/render-poster/back_ground.jpg"
          : "/assets/imgs/render-poster/back_groundN.jpg";
      case 4:
        return type === 1
          ? "/assets/imgs/render-poster/back_ground.jpg"
          : "/assets/imgs/render-poster/back_groundN2.jpg";
      default:
        return type === 1
          ? "/assets/imgs/render-poster/back_ground.jpg"
          : "/assets/imgs/render-poster/back_groundN.jpg";
    }
  };
  const renderAvatarUser = async (ctxA1, canvasA1, avtObj, type) => {
    let avatar;
    switch (avtObj.length) {
      case 1:
        avatar = type === 1
          ? "/assets/imgs/render-poster/avatar1.png"
          : "/assets/imgs/render-poster/avatar1.png";
        await addImageAvatar(
          ctxA1,
          avatar,
          type === 1 ? 297 : 135,
          type === 1 ? 431 : 431,
          avtObj[0]?.file || "/assets/imgs/render-poster/a1.png",
          avtObj.length,
          type,
          avtObj[0]?.name
        );
        break;

      case 2:
        avatar = type === 1
          ? "/assets/imgs/render-poster/avatar2.png"
          : "/assets/imgs/render-poster/avatarN2.png";
        await addImageAvatar(
          ctxA1,
          avatar,
          type === 1 ? 70 : 195,
          type === 1 ? 450 : 405,
          avtObj[0]?.file || "/assets/imgs/render-poster/a1.png",
          avtObj.length,
          type,
          avtObj[0].name
        );
        await addImageAvatar(
          ctxA1,
          avatar,
          type === 1 ? 541 : 1233,
          type === 1 ? 450 : 407,
          avtObj[1]?.file || "/assets/imgs/render-poster/a1.png",
          avtObj.length,
          type,
          avtObj[1].name
        );
        break;

      case 3:
        avatar = type === 1
          ? "/assets/imgs/render-poster/avatar3.png"
          : "/assets/imgs/render-poster/avatarN3.png";
        await addImageAvatar(
          ctxA1,
          avatar,
          type === 1 ? 20 : 247,
          type === 1 ? 506 : 324,
          avtObj[0]?.file || "/assets/imgs/render-poster/a1.png",
          avtObj.length,
          type,
          avtObj[0].name
        );
        await addImageAvatar(
          ctxA1,
          avatar,
          type === 1 ? 371 : 62,
          type === 1 ? 506 : 671,
          avtObj[1]?.file || "/assets/imgs/render-poster/a1.png",
          avtObj.length,
          type,
          avtObj[1]?.name
        );
        await addImageAvatar(
          ctxA1,
          avatar,
          type === 1 ? 722 : 416,
          type === 1 ? 506 : 671,
          avtObj[2]?.file || "/assets/imgs/render-poster/a1.png",
          avtObj.length,
          type,
          avtObj[2].name
        );
        break;

      case 4:
        avatar = type === 1
          ? "/assets/imgs/render-poster/avatar4.png"
          : "/assets/imgs/render-poster/avatarN4.png";
        await addImageAvatar(
          ctxA1,
          avatar,
          type === 1 ? 62 : 65,
          type === 1 ? 423 : 451,
          avtObj[0].file || "/assets/imgs/render-poster/a1.png",
          avtObj.length,
          type,
          avtObj[0].name
        );
        await addImageAvatar(
          ctxA1,
          avatar,
          type === 1 ? 532 : 426,
          type === 1 ? 423 : 451,
          avtObj[1].file || "/assets/imgs/render-poster/a1.png",
          avtObj.length,
          type,
          avtObj[1].name
        );
        await addImageAvatar(
          ctxA1,
          avatar,
          type === 1 ? 297 : 1115,
          type === 1 ? 624 : 451,
          avtObj[2].file || "/assets/imgs/render-poster/a1.png",
          avtObj.length,
          type,
          avtObj[2].name
        );
        await addImageAvatar(
          ctxA1,
          avatar,
          type === 1 ? 767 : 1475,
          type === 1 ? 624 : 451,
          avtObj[3].file || "/assets/imgs/render-poster/a1.png",
          avtObj.length,
          type,
          avtObj[3].name
        );
        break;

      default:
        avatar = type === 1
          ? "/assets/imgs/render-poster/avatar1.png"
          : "/assets/imgs/render-poster/avatar1.png";
        await addImageAvatar(
          ctxA1,
          avatar,
          canvasA1.width / 2 - 270,
          400,
          "/assets/imgs/render-poster/a1.png",
          avtObj.length,
          type
        );
        break;
    }
  };

  const addImageAvatar = async (
    ctxt,
    linkImage,
    width,
    height,
    linkImageUser,
    type,
    typeImage,
    nameUser
  ) => {
    const {
      widthx,
      heighty,
      withText,
      heightwithText,
      WidthAvatar,
      HeightAvatar,
    } = getXYImage(type, typeImage);

    try {
      const image = new Image();
      image.crossOrigin = "anonymous";
      image.src = linkImage;

      const canvasB = document.createElement("canvas");
      const ctxB = canvasB.getContext("2d");

      await new Promise((resolve, reject) => {
        image.onload = async () => {
          try {
            const avataUser = new Image();
            avataUser.crossOrigin = "anonymous";
            avataUser.src = linkImageUser || "/assets/imgs/render-poster/a1.png";
            avataUser.width = WidthAvatar;
            avataUser.height = HeightAvatar;

            await new Promise((resolve, reject) => {
              avataUser.onload = () => {
                canvasB.width = avataUser.width;
                canvasB.height = avataUser.height;
                const centerX = avataUser.width / 2;
                const centerY = avataUser.height / 2;
                const radius = Math.min(centerX, centerY);
                
                ctxB.save();
                ctxB.beginPath();
                ctxB.arc(centerX, centerY, radius, 0, 2 * Math.PI);
                ctxB.closePath();
                ctxB.clip();
                
                ctxB.drawImage(avataUser, 0, 0, avataUser.width, avataUser.height);
                ctxB.restore();

                ctxt.drawImage(canvasB, width + widthx, height + heighty);
                ctxt.drawImage(image, width, height, image.width, image.height);

                if (nameUser) {
                  insertText(
                    ctxt,
                    nameUser,
                    "35px UTM Centur, sans-serif",
                    "#401C0E",
                    "center",
                    width + withText,
                    height + heightwithText
                  );
                }
                resolve();
              };
              avataUser.onerror = () => {
                console.error("Error loading avatar image");
                reject(new Error("Failed to load avatar image"));
              };
            });
            resolve();
          } catch (error) {
            reject(error);
          }
        };
        image.onerror = () => {
          console.error("Error loading frame image");
          reject(new Error("Failed to load frame image"));
        };
      });
    } catch (error) {
      console.error("Error adding avatar:", error);
      message.error("Lỗi khi thêm ảnh. Vui lòng thử lại.");
    }
  };

  const getXYImage = (type, typeImage) => {
    switch (type) {
      case 1:
        return {
          withText: typeImage === 1 ? 280 : 280,
          heightwithText: typeImage === 1 ? 435 : 435,
          WidthAvatar: typeImage === 1 ? 380 : 380,
          HeightAvatar: typeImage === 1 ? 380 : 380,
          widthx: typeImage === 1 ? 80 : 80,
          heighty: typeImage === 1 ? 80 : 80,
        };
      case 2:
        return {
          withText: typeImage === 1 ? 250 : 230,
          heightwithText: typeImage === 1 ? 425 : 375,
          WidthAvatar: typeImage === 1 ? 350 : 330,
          HeightAvatar: typeImage === 1 ? 350 : 330,
          widthx: typeImage === 1 ? 80 : 60,
          heighty: typeImage === 1 ? 80 : 55,
        };
      case 3:
        return {
          withText: typeImage === 1 ? 190 : 190,
          heightwithText: typeImage === 1 ? 320 : 330,
          WidthAvatar: typeImage === 1 ? 270 : 300,
          HeightAvatar: typeImage === 1 ? 270 : 300,
          widthx: typeImage === 1 ? 60 : 60,
          heighty: typeImage === 1 ? 55 : 55,
        };
      case 4:
        return {
          withText: typeImage === 1 ? 150 : 170,
          heightwithText: typeImage === 1 ? 250 : 300,
          WidthAvatar: typeImage === 1 ? 210 : 270,
          HeightAvatar: typeImage === 1 ? 210 : 270,
          widthx: typeImage === 1 ? 40 : 40,
          heighty: typeImage === 1 ? 40 : 40,
        };
      default:
        return {
          withText: typeImage === 1 ? 280 : 280,
          heightwithText: typeImage === 1 ? 435 : 435,
          WidthAvatar: typeImage === 1 ? 380 : 380,
          HeightAvatar: typeImage === 1 ? 380 : 380,
          widthx: typeImage === 1 ? 80 : 80,
          heighty: typeImage === 1 ? 80 : 80,
        };
    }
  };

  const insertText = (
    ctxt,
    text,
    font,
    fillStyle,
    textAlign,
    width,
    height
  ) => {
    ctxt.font = font;
    ctxt.fillStyle = fillStyle;
    ctxt.textAlign = textAlign;
    ctxt.textBaseline = "middle";
    ctxt.fillText(text, width, isIphone ? height - 10 : height);
  };

  const dataURLtoBlob = (dataUrl) => {
    const arr = dataUrl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };

  const handleDownload = () => {
    try {
      if (!canvasA1Element) {
        message.error("Canvas not ready. Please wait.");
        return;
      }
      const dataUrl = canvasA1Element.toDataURL("image/png");
      const a = document.createElement("a");
      a.href = dataUrl;
      a.download = "downloaded_image.png";
      a.click();
    } catch (error) {
      console.error("Error downloading image:", error);
      message.error("Error downloading image. Please try again.");
    }
  };

  const uploadFile = async () => {
    try {
      if (!canvasA1Element) {
        message.error("Canvas not ready. Please wait.");
        return;
      }
      
      const dataUrl = canvasA1Element.toDataURL("image/png");
      const blob = dataURLtoBlob(dataUrl);

      const formData = new FormData();
      formData.append("file", blob, "canvas_image.png");
      
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };

      const result = await axios.post("upload/image_logo", formData, config);

      const items = {
        image_url: result.data.url,
      };
      
      await axios.post("banners", items);
      message.success("Upload file thành công");
    } catch (error) {
      console.error("Error uploading file:", error);
      message.error(
        error?.response?.data?.message ||
          "Kết nối không ổn định, Vui lòng thử lại sau!"
      );
    }
  };

  const isLessThan530 = useMediaQuery({ query: "(max-width: 530px)" });
  const isLessThan720 = useMediaQuery({ query: "(max-width: 720px)" });

  useEffect(() => {
    const userAgent = navigator.userAgent;
    setIsMobile(/Mobi/.test(userAgent));

    if (/iPhone|iPad|iPod/i.test(userAgent)) {
      setIsIphone(true);
    } else if (/Android/i.test(userAgent)) {
      setIsIphone(false);
    }
  }, []);

  const GenderViewButton = () => {
    return (
      <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
        <Button
          hidden={!isMobile}
          type="primary"
          onClick={() => setHidenView(true)}
        >
          Back
        </Button>
        <Button
          type="primary"
          style={{ marginLeft: 20 }}
          icon={<DownloadOutlined />}
          onClick={handleDownload}
        >
          Download
        </Button>

        {typeImage === 2 && (
          <Button
            type="primary"
            style={{ marginLeft: 20 }}
            onClick={uploadFile}
          >
            Upload
          </Button>
        )}
      </div>
    );
  };

  return (
    <div
      style={{
        width: "100%",
        // padding: "1rem",
        display: "flex",
        alignItems: "start",
        justifyContent: "center",
        position: "relative",
        // marginTop: 50,
      }}
    >
      {hidenView ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "30rem",
            gap: "1rem",
            padding: "1.5rem",
            background: "#fff",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
          <div style={{ marginBottom: "1rem" }}>
            <h3 style={{ marginBottom: "0.5rem", color: "#333" }}>Thông tin cơ bản</h3>
            <Select
              style={{ width: "100%" }}
              placeholder="Loại ảnh"
              onChange={(value) => setTypeImage(value)}
              options={[
                { value: 1, label: "Dọc" },
                { value: 2, label: "Ngang" },
              ]}
            />
            <Input
              style={{ marginTop: "0.5rem" }}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Tiêu đề"
            />
          </div>

          <div>
            <h3 style={{ marginBottom: "0.5rem", color: "#333" }}>Thông tin giao dịch</h3>
            <Input
              style={{ marginBottom: "0.5rem" }}
              onChange={(e) => setProjectName(e.target.value)}
              placeholder="Tên dự án"
            />
            <Select
              style={{ width: "100%", marginBottom: "0.5rem" }}
              placeholder="Nhu cầu"
              onChange={(value) => setPaymentType(value)}
              options={[
                { value: "Bán", label: "Bán" },
                { value: "Cho Thuê", label: "Cho Thuê" },
              ]}
            />
            <Input
              style={{ marginBottom: "0.5rem" }}
              onChange={(e) => setDepartmentCode(e.target.value)}
              placeholder="Ngày chốt"
            />
            <Input
              style={{ marginBottom: "0.5rem" }}
              placeholder="Giá trị căn hộ"
              onChange={(e) => setDepartmentValue(e.target.value)}
            />
            <Input
              style={{ marginBottom: "0.5rem" }}
              onChange={(e) => setBonus(e.target.value)}
              placeholder="Ngày ký"
            />
          </div>

          <Divider style={{ margin: "1rem 0" }} />

          <div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
              <h3 style={{ color: "#333" }}>Thông tin chuyên viên</h3>
              <Button
                disabled={avtObj.length >= 4}
                onClick={async () => {
                  const newAvtObj = [...avtObj];
                  newAvtObj.push({
                    file: "",
                    name: "",
                    id: generateRandomString(12)
                  });
                  setAvtObj(newAvtObj);
                  await createCanvas();
                }}
                type="primary"
                size="small"
              >
                Thêm ảnh
              </Button>
            </div>

            {avtObj.map((_item, index) => (
              <div key={index} style={{ 
                background: "#f5f5f5", 
                padding: "1rem", 
                borderRadius: "4px", 
                marginBottom: "0.5rem" 
              }}>
                <p style={{ marginBottom: "0.5rem", fontWeight: "500" }}>Avatar {index + 1}</p>
                <div>
                  <div style={{ display: "flex", gap: "0.5rem", marginBottom: "0.5rem" }}>
                    <Upload {...uploadProps(index)}>
                      <Button icon={<UploadOutlined />}>Chọn ảnh</Button>
                    </Upload>
                    <Button
                      disabled={avtObj.length === 1}
                      onClick={() => {
                        const list = avtObj.filter((it) => it.id !== _item.id);
                        setAvtObj(list);
                      }}
                      danger
                    >
                      Xóa
                    </Button>
                  </div>

                  <Input
                    onChange={(e) => {
                      const newAvtObj = [...avtObj];
                      newAvtObj[index] = {
                        ...newAvtObj[index],
                        name: e.target.value,
                      };
                      setAvtObj(newAvtObj);
                    }}
                    placeholder="Tên chuyên viên"
                  />
                </div>
              </div>
            ))}
          </div>

          <Divider style={{ margin: "1rem 0" }} />

          

          <Button
            hidden={!isMobile}
            loading={isLoading}
            onClick={async () => {
              await createCanvas();
              setHidenView(false);
            }}
            type="primary"
            style={{ marginTop: "1rem" }}
          >
            Next
          </Button>
        </div>
      ) : null}

      <div>
        <div style={{ marginLeft: 20 }}>
          <canvas
            style={{
              border: "1px solid black",
              width: `${isMobile ? "100%" : typeImage === 1 ? "360px" : "700px"}`,
            }}
            hidden={isMobile ? hidenView : false}
            id="myCanvasB"
            ref={canvasRefB}
            width={
              typeImage === 1
                ? isLessThan530
                  ? "350"
                  : "500"
                : isLessThan720
                ? "360"
                : "700"
            }
            height={
              typeImage === 1
                ? isLessThan530
                  ? "490"
                  : "700"
                : isLessThan720
                ? "206"
                : "400"
            }
          />
        </div>

        {isMobile ? (
          hidenView ? null : <GenderViewButton />
        ) : (
          <GenderViewButton />
        )}
      </div>
    </div>
  );
};

export default RenderPoster;
